import {
    AfterViewInit,
    Component,
    EventEmitter,
    Input,
    Output,
} from "@angular/core";
import * as _ from "lodash";
import {Bot} from "../../../../../../../models/bot";
import {DataMapping} from "../../../../../../../models/data-mapping";
import {DataMappingHelpers} from "../../../../../../../models/data-mapping-helpers";
import {MuleMapping} from "../../../../../../../models/mule-mapping";
import { BaseError } from "../../../../../base-error";
import {ToastrService} from "ngx-toastr";

@Component({
    selector: "right-side",
    templateUrl: "./right-side.component.html",
})
export class RightSideComponent extends BaseError implements AfterViewInit {

    @Input() public serviceId: string;
    @Input() public bot: Bot;
    @Input() public fields: any[]; // main guy here
    @Input() public hideFields: any;
    @Input() public lines: any[] = [];
    @Input() public dragSrc: any = { el: null };
    @Input() public isDragging: any = {value: false};
    @Input() public generateRightEstructure: boolean = false;
    @Input() public filter: any;
    @Input() public selectedTab: any = null;
    @Input() public visible: boolean;
    @Input() public muleServiceItems: MuleMapping[];
    @Input() public rightPrefix: string;
    @Input() public leftPrefix: string;
    @Input() public type: string;
    @Input() public checkingVisibility: any = { value: false };
    @Input() public boardId: string;
    @Input() public isLtr: boolean;

    @Output("handleScroll") public handleScroll: EventEmitter<any> = new EventEmitter();
    @Output("addRelationship") public addRelationship: EventEmitter<any> = new EventEmitter();
    @Output("setSelectedMuleService") public setSelectedMuleService: EventEmitter<any> = new EventEmitter();
    @Output("saveLines") public saveLines: EventEmitter<any> = new EventEmitter();
    @Output("removeSelection") public removeSelection: EventEmitter<any> = new EventEmitter();
    @Output("removeRelationship") public removeRelationship: EventEmitter<any> = new EventEmitter();
    @Output("updateHiddenServiceFields") public updateHiddenServiceFields: EventEmitter<any> = new EventEmitter();
    @Output("addDataTransformation") public addDataTransformation: EventEmitter<any> = new EventEmitter();

    constructor(public toastr: ToastrService) {
        super(toastr);
    }

    public ngAfterViewInit(): void {
        if (!this.checkingVisibility.value) {
            this.checkingVisibility.value = true;
            this.handleScroll.emit();
        }
    }

    public changeGroupMetaAfterNgOnChange(args) {
        // const hasInputsVisible = this.haveInputsVisible(args.fieldItem);
        if (!args.fieldItem.meta) { args.fieldItem.meta = {}; }
        if (!args.fieldItem.meta.groupRowClasses) { args.fieldItem.meta.groupRowClasses = {}; }
        if (!args.fieldItem.meta.groupEyeClasses) { args.fieldItem.meta.groupEyeClasses = {}; }
        // args.fieldItem.meta.groupRowClasses.hiddenRow = !(args.isRoot || (args.parentFieldItem && args.parentFieldItem.isopen)) || !this.visible && !hasInputsVisible;
        // args.fieldItem.meta.groupEyeClasses["fa-eye"] = hasInputsVisible;
        // args.fieldItem.meta.groupEyeClasses["fa-eye-slash"] = !hasInputsVisible;
    }

    public changeGroupMetaAfterLineChange(fieldItem) {
        if (!fieldItem.meta) { fieldItem.meta = {}; }
        if (!fieldItem.meta.groupInnerRowClasses) { fieldItem.meta.groupInnerRowClasses = {}; }
        fieldItem.meta.groupInnerRowClasses["connected-child"] = this.haveInputGroupRelationship(fieldItem);
    }

    public static customClassForGroupInnerRow(fieldItem, type): string {
        if (type === "input") { return "inputs-block-header-" + DataMappingHelpers.getSanitizeGroupName(fieldItem.name || type); }
        return "outputs-block-header-" + DataMappingHelpers.getSanitizeGroupName(fieldItem.name || type);
    }

    public getSanitizeID(type, prefix = ""): string {
        return DataMappingHelpers.getSanitizeID(type, prefix);
    }

    public haveRelationship(input): boolean {
        return DataMappingHelpers.haveRelationship(this.lines, input);
    }

    public haveInputGroupRelationship(fieldItem): boolean {
        if (!fieldItem) {
            return false;
        }
        if (fieldItem.isgroup) {
            /*
            if (fieldItem.type === "editgrid") {
                return this.haveRelationship(fieldItem.field);
            }
            */
            return fieldItem.items.some((item) => {
                return this.haveInputGroupRelationship(item);
            });
        }
        if (this.bot.botType === "internal") {
            return this.muleServiceItems.some((msi) => {
                return msi.fieldKey === fieldItem.field.fieldKey && this.haveRelationship(msi);
            });
        }
        if (fieldItem.type === "editgrid") {
            return this.haveRelationship(fieldItem.field);
        }
        return this.muleServiceItems.some((msi) => {
            return msi.id === (fieldItem.field.id) && this.haveRelationship(msi);
        });
    }

    public haveInputsVisible(fieldItem): boolean {
        if (fieldItem.isgroup) {
            return fieldItem.items.some((item) => {
                return this.haveInputsVisible(item);
            });
        }
        return this.hideFields[fieldItem.field.name || fieldItem.field.fieldName] === false
            || this.hideFields[fieldItem.field.name || fieldItem.field.fieldName] === null
            || this.hideFields[fieldItem.field.name || fieldItem.field.fieldName] === undefined;
    }

    private propagateToggleGroupVisibility(fieldItem, visible): void {
        if (fieldItem.isgroup) {
            return fieldItem.items.forEach((item) => {
                return this.propagateToggleGroupVisibility(item, visible);
            });
        }
        this.hideFields[fieldItem.field.name || fieldItem.field.fieldName] = visible;
    }

    public toggleGroupVisibility(fieldItem): void {
        this.propagateToggleGroupVisibility(fieldItem, this.haveInputsVisible(fieldItem));
        if (!this.checkingVisibility.value) {
            this.checkingVisibility.value = true;
            this.handleScroll.emit();
        }
        this.updateHiddenServiceFields.emit();
    }

    public setInputField(args): void {
        const options = Object(args);

        if (options.fieldKey) {
            const dataMapping = new DataMapping();
            dataMapping.sourceField = options.fieldKey;
            dataMapping.sourceType = options.fieldType;
            dataMapping.targetField = options.inputId;
            dataMapping.targetType = options.targetType;
            this.bot.inputFieldsMapping.push(dataMapping);
        }
    }

    public toggleBlock(group): void {
        group.isopen = !group.isopen;
        if (!this.checkingVisibility.value) {
            this.checkingVisibility.value = true;
            this.handleScroll.emit();
        }
    }

    public handleEndPointSelection(args): void {
        const options = Object(args);
        if (!this.isDragging.value) { return; }
        if (_.isEqual(this.dragSrc.el, options.input) && this.serviceId === this.bot.botServiceId ) { return; }
        const tempMapping = {
            fieldKey: this.dragSrc.el.fieldKey,
            fieldType: this.dragSrc.el.remoteType,
            inputId: (options.input.id || options.input.fieldKey),
            targetType: options.input && options.input.type,
        };
        const tempLine = {
            type: options.type,
            field: this.dragSrc.el,
            input: options.input,
            startPoint: DataMappingHelpers.getSanitizeID(this.dragSrc.el.fieldKey, this.leftPrefix),
            endPoint: DataMappingHelpers.getSanitizeID(options.selector, this.rightPrefix),
            boardId: this.boardId,
        };
        console.log("--- handleEndPointSelection", options, tempMapping, tempLine);
        this.addRelationship.emit({
            map: tempMapping,
            line: tempLine,
            isLtr: true,
        });
        this.removeSelection.emit();
    }

    public handleStartPointSelection(input): void {
        if (_.isEqual(this.dragSrc.el, input)) { return this.removeSelection.emit(); }
        if (this.dragSrc.el !== null) { this.removeSelection.emit(); }
        this.isDragging.value = true;
        this.dragSrc.el = input;
    }

    public showHideField(input): void {
        this.hideFields[input.name] = !this.hideFields[input.name];
        if (!this.checkingVisibility.value) {
            this.checkingVisibility.value = true;
            this.handleScroll.emit();
        }
        this.updateHiddenServiceFields.emit();
    }

    public deleteSelection(id: any): void {
        this.bot.inputFieldsMapping = this.bot.inputFieldsMapping
            .filter((ifm) => ifm.id !== id);
        console.log(this.bot.inputFieldsMapping);
        this.removeRelationship.emit(id);
    }

    public onAddDataTransformation(fieldItem): void {
        this.addDataTransformation.emit({field: fieldItem, boardId: this.boardId});
    }
}
